import axios from 'axios';
import Estabelecimento from '../domain/Estabelecimentos.tsx';


const api = axios.create({
  baseURL: '/', 
  headers: {
    'Content-Type': 'application/json',
  },
});

export const login = async (identifier: any, senha: any) => {
  try{
    const response = await api.post('/auth/login', { identifier: identifier, senha: senha });
    return response.data;
  } catch (error) {
    console.error('Erro ao logar:', error);
    throw error;
  }
}

export const getLocais = async (): Promise<Estabelecimento[]> => {
  const token = localStorage.getItem("@Sergipanidade:token");
  try {
    const response = await api.get('/locais', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar locais:', error);
    throw error;
  }
}

export interface SavedRouteStep {
  id: string;
  time: string;
  localId: number;
  nome: string;
  tipo: string;
  cidade: string;
  endereco?: string;
  latitude?: number;
  longitude?: number;
  imagem?: string;
}

export interface SavedRoute {
  id?: string | null;
  dayNumber: number;
  date: string;
  createdAt?: string;
  steps: SavedRouteStep[];
}

export const getLocalById = async (id: number): Promise<Estabelecimento | undefined> => {
  const locais = await getLocais();
  return locais.find((local) => local.id.toString() === id.toString());
};

export const saveRoute = async (route: SavedRoute) => {
  const token = localStorage.getItem("@Sergipanidade:token");
  route.id = null;
  try {
    const response = await api.post('/roteiros', route, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Falha ao salvar roteiro no servidor:', error);
    throw error;
  }
};

export const getRoutes = async (): Promise<SavedRoute[]> => {
  const token = localStorage.getItem("@Sergipanidade:token");
  try {
    const response = await api.get('/roteiros', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Falha ao carregar roteiros do servidor:', error);
    throw error;
  }
};

/* ═══════════════════════════════════════════════════════════════════════════
  Admin API — Endpoints para o painel administrativo
   ═══════════════════════════════════════════════════════════════════════════ */

const getAuthHeaders = () => {
  const token = localStorage.getItem("@Sergipanidade:token");
  return { Authorization: `Bearer ${token}` };
};

/* ─── Usuários ───────────────────────────────────────────────────────────── */
export const getUsuarios = async () => {
  try {
    const response = await api.get('/users', {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar usuários:', error);
    throw error;
  }
};

export const deleteUsuario = async (id: number) => {
  try {
    const response = await api.delete(`/users/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao deletar usuário:', error);
    throw error;
  }
};

/* ─── Estabelecimentos (admin) ───────────────────────────────────────────── */
export const getEstabelecimentos = async () => {
  try {
    const response = await api.get('/locais', {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar estabelecimentos:', error);
    throw error;
  }
};

export const deleteEstabelecimento = async (id: number) => {
  try {
    const response = await api.delete(`/locais/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao deletar estabelecimento:', error);
    throw error;
  }
};

export default api;